import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/snjs';
const styles = {
    base: 'active:border-info active:bg-info active:text-neutral-contrast flex-grow cursor-pointer rounded-full border border-solid px-2 py-1 text-center transition text-sm',
    unselected: 'text-neutral border-secondary-border bg-default',
    selected: 'text-neutral-contrast border-info bg-info',
};
const Bubble = ({ label, selected, onSelect }) => (_jsx("button", { role: "checkbox", "aria-checked": selected, className: classNames(styles.base, selected ? styles.selected : styles.unselected), onClick: onSelect, children: label }));
export default Bubble;
